import useT from '@hooks/useTranslation'
import styles from 'styles/LabelH.module.css'

const Label = ({ center, text, required }) => (
    <h2 className={styles.h} required={required} center={center ? 'true' : undefined}><span>{useT(text)}</span></h2>
)

export default Label